@if (!config.hasOwnProperty('showGrid') || context[config.showGrid]) {
  @if (dataError) {
    <div class="checkbox-matrix--error">
      {{ config.errorMessage || 'Data Error, try again at another time.' }}
    </div>
  }
  @if (!dataError) {
    <div class="checkbox-matrix">
      @if (config.hasOwnProperty('radioConfig')) {
        <div
          [formGroup]="radioFormGroup"
          class="checkbox-matrix__radio-wrapper"
        >
          @for (option of config.radioConfig.options; track option) {
            <div>
              <label
                [attr.aria-label]="config.radioConfig.prop"
                class="form-control--radio__wrapper"
              >
                <input
                  type="radio"
                  class="form-control form-control--radio"
                  [value]="option.value"
                  [formControlName]="config.radioConfig.prop"
                />
                <p class="t-data" [innerHtml]="option.label"></p>
              </label>
            </div>
          }
        </div>
      }
      <div class="checkbox-grid">
        <div class="checkbox-grid__header-wrapper">
          <div class="checkbox-grid__title-wrapper">
            <p class="t-bold">{{ config.title }}</p>
          </div>
          <div class="checkbox-grid__titles-wrapper">
            <div class="checkbox-grid__titles--container">
              <form [formGroup]="headerFormGroup">
                <div class="checkbox-grid__titles">
                  @for (column of gridData[config.columns]; track column) {
                    <div
                      class="checkbox-grid__title"
                      [style.width.%]="100 / gridData[config.columns].length"
                    >
                      <label
                        [for]="column[config.columnIdProp]"
                        attr.aria-label="Toggle {{ column.short_name }}"
                        class="form-control--checkbox__wrapper"
                      >
                        @if (
                          !config?.hasOwnProperty('readOnly') &&
                          !config?.isHidden &&
                          hasCheckboxes(column[config?.columnIdProp]) &&
                          (config?.hasOwnProperty('radioConfig')
                            ? radioFormGroup.controls[config?.radioConfig?.prop]
                                .value
                            : true)
                        ) {
                          <input
                            class="form-control form-control--checkbox"
                            type="checkbox"
                            [id]="column[config.columnIdProp]"
                            [formControlName]="column[config.columnIdProp]"
                            (change)="
                              toggleColumn(
                                column[config.columnIdProp],
                                headerFormGroup.controls[
                                  column[config.columnIdProp]
                                ].value
                              )
                            "
                          />
                        }
                        <p class="t-bold" [innerHtml]="column.short_name"></p>
                      </label>
                    </div>
                  }
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="checkbox-grid__rows-wrapper">
          <div class="checkbox-grid__grid-wrapper">
            @for (
              group of objectToArray(checkboxFormGroup.controls);
              track group;
              let groupIndex = $index
            ) {
              <div class="checkbox-grid__row">
                <form [formGroup]="group" class="checkbox-grid__grid">
                  <div class="checkbox-grid__rowLabels-wrapper">
                    <div class="checkbox-grid__rowLabel">
                      <p
                        class="t-bold"
                        [innerHtml]="
                          gridData[config.rows][groupIndex].short_name
                        "
                      ></p>
                    </div>
                    <p
                      class="t-caption"
                      [innerHtml]="
                        gridData[config.rows][groupIndex].detail_text
                      "
                    ></p>
                  </div>
                  <div class="checkbox-grid__cells-wrapper">
                    @for (
                      column of gridData[config.columns];
                      track column;
                      let columnIndex = $index
                    ) {
                      <div class="u-flex u-fillRemaining">
                        @if (
                          group.controls[column[config.columnIdProp]];
                          as control
                        ) {
                          @if (
                            config.isHidden ||
                            (config.hasOwnProperty('radioConfig') &&
                              !radioFormGroup.get(config.radioConfig.prop)
                                .value)
                          ) {
                            <span> </span>
                          } @else {
                            @if (config.hasOwnProperty('readOnly')) {
                              <span>
                                @if (
                                  group.controls[column[config.columnIdProp]]
                                    .value
                                ) {
                                  <span>
                                    @if (config.readOnly.character) {
                                      <span
                                        [innerHTML]="config.readOnly.character"
                                      >
                                      </span>
                                    } @else {
                                      <i class="icon icon--medium icon--pointer"
                                        >check</i
                                      >
                                    }
                                  </span>
                                }
                              </span>
                            } @else {
                              <label
                                [attr.aria-label]="
                                  column[config.columnIdProp].heading
                                "
                                class="form-control--checkbox__wrapper"
                              >
                                <input
                                  (change)="
                                    matrixItemChange(
                                      column[config.columnIdProp]
                                    )
                                  "
                                  class="form-control form-control--checkbox"
                                  type="checkbox"
                                  [formControlName]="
                                    column[config.columnIdProp]
                                  "
                                />
                              </label>
                            }
                          }
                        }
                      </div>
                    }
                  </div>
                </form>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
}
